
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"60","height":"60"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2","d":"M55.83 27.9L30 2.07 4.17 27.9M48.3 20.4v37.53M11.7 57.93V20.4M11.92 49A9 9 0 001.5 57.93h57A9 9 0 0048.08 49"}}),_c('path',{attrs:{"d":"M41 33.2A5.72 5.72 0 0030 31a5.72 5.72 0 00-11 2.2h0c0 3.08 1.83 7.16 11 13.32 9.17-6.16 11-10.24 11-13.32z","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}})])
          )
        }
      }
    